import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchWorkLocation = createAsyncThunk(
  'workLocation/fetchWorkLocation',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetWorkLocation();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  workLocationList: [],
  loading: false,
  error: '',
};

const workLocationSlice = createSlice({
  name: 'workLocation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkLocation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWorkLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.workLocationList = action.payload;
        state.error = '';
      })
      .addCase(fetchWorkLocation.rejected, (state, action) => {
        state.loading = false;
        state.workLocationList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default workLocationSlice.reducer;
